<script>
  // original vRoot/_core/RbDropdown.vue is used in a lot of places
  import {createEventDispatcher, onMount, onDestroy} from 'svelte';
  import Popper from 'popper.js';

  export let
    isOpen = false,
    backdrop = true,
    backdropStyle = '',
    align = 'bottom-start', // options: 'bottom-start', 'bottom-end',...
    classes = '';

  const dispatch = createEventDispatcher();

  let popup, popupElement, targetElement;

  $: reposition(isOpen)

  onMount(() => {
    popup = new Popper(targetElement, popupElement, {
      placement: align,
      modifiers: {
        preventOverflow: {
          boundariesElement: 'window',
        },
      }
    });
  });

  onDestroy(() => {
    if(popup) popup.destroy();
  });

  function reposition(open) {
    if(open) popup.update();
  }

  function close() {
    dispatch('close');
  }

</script>


<div class="{classes}"
     bind:this={targetElement}
>
  <div class="rbvDropDownToggler">
    <slot name="toggler" />
  </div>

  <div class="rbvDropDown"
       class:rbvDropDownRightAlign="{align === 'right'}"
       bind:this={popupElement}
       on:click|stopPropagation|preventDefault
  >
    {#if isOpen}
      <slot name="dropdown" />
    {/if}
  </div>

  {#if isOpen && backdrop}
    <div class="{`rbvDropDownBackdrop ${backdropStyle}`}"
         on:click="{close}"
    />
  {/if}
</div>

<style lang="stylus">
  .rbvDropDownToggler {
    z-index 5001;
  }

  .rbvDropDown {
    z-index 5002;
  }

  .rbvDropDownBackdrop {
    position fixed
    top 0
    left 0
    width 100vw
    height 100vh
    background rgba(0,0,0,.5)
    z-index 5000

    &.transparent {
      background transparent
    }
  }
</style>
